import React from 'react';
import styled from 'styled-components';

const RightContentWrapper = styled.div`
  width: 34%;
  margin-left: 5px;
`;

const TableTitle = styled.h2`
  border: 1px solid yellow;
  margin: 10px;
  font-family: 'Times New Roman';
  font-size: 12px;
  font-weight: bold;
  font-style: italic;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid yellow;
    padding: 3px;
    font-family: 'Times New Roman';
    font-size: 10px;
  }

  tr:nth-child(even) {
    background-color: deepblue;
  }
`;

const RightContent = () => {
  const rows = new Array(20).fill(null);

  return (
    <RightContentWrapper>
      <TableTitle>Portfolio Summary</TableTitle>
      <Table>
        <thead>
          <tr>
            {new Array(2).fill(null).map((_, index) => (
              <th key={index}>Header {index + 1}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((_, rowIndex) => (
            <tr key={rowIndex}>
              {new Array(2).fill(null).map((_, cellIndex) => (
                <td key={cellIndex}>Data {rowIndex + 1}-{cellIndex + 1}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </RightContentWrapper>
  );
};

export default RightContent;

